import { render, staticRenderFns } from "./pathogenesis_analysis.vue?vue&type=template&id=3e8ac6c5&scoped=true&"
import script from "./pathogenesis_analysis.vue?vue&type=script&lang=js&"
export * from "./pathogenesis_analysis.vue?vue&type=script&lang=js&"
import style0 from "./pathogenesis_analysis.vue?vue&type=style&index=0&id=3e8ac6c5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8ac6c5",
  null
  
)

export default component.exports